const actions = {
  //- Sets the list of approved companies
  setApprovedCompaniesCriterias ({ commit }, criterias) {
    //- Mutate store
    commit('SET_APPROVED_CRITERIAS', criterias)
  },
  //- Sets the list of non approved companies
  setUnapprovedCompaniesCriterias ({ commit }, criterias) {
    //- Mutate store
    commit('SET_UNAPPROVED_CRITERIAS', criterias)
  },
  //- Sets the boolean to indentify if the company is approved or not
  setCompaniesIsApproved ({ commit }, isApproved) {
    //- Mutate store
    commit('SET_ISAPPROVED_COMPANIES', isApproved)
  }
}

export default actions
